import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setBreadcrumb } from 'components/Navbar/modules';
import { resetAll } from 'modules/steps/actions';
import { cleanUsersFromNarrative } from 'routes/Narratives/modules';
import SpeedDating from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.speedDating || {},
    app: state.app,
    meetings: state.speedDating.meetings,
    newUsersInNarratives: state.narratives.newUsersInNarratives,
    actualUser: state.session.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
    cleanUsersFromNarrative: bindActionCreators(cleanUsersFromNarrative, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SpeedDating));



// WEBPACK FOOTER //
// ./src/routes/SpeedDating/container/index.js